import Vue from "vue";
import VueI18n from "vue-i18n";
import i18nEN from "@/languages/en";
import i18nID from "@/languages/id";
import i18nAR from "@/languages/ar";

Vue.use(VueI18n);

// Keep internal message keys uppercase (legacy) but expose a simple setter that accepts lowercase codes.
const messages = { EN: i18nEN, ID: i18nID, AR: i18nAR };

const i18n = new VueI18n({
  // Start with EN; real initial language will be applied asynchronously by languageDetection
  locale: 'EN',
  fallbackLocale: 'EN',
  messages,
});

// Expose a controlled setter mapping lowercase codes to existing message keys.
export function applyI18nLocale(lowercaseCode) {
  const map = { en: 'EN', id: 'ID', ar: 'AR' };
  const target = map[lowercaseCode] || 'EN';
  if (i18n.locale !== target) {
    i18n.locale = target;
  }
}

// Optional: attach reference for languageDetection fallback if apply function not provided.
if (typeof window !== 'undefined') {
  window.__appI18nInstance = i18n;
}

export default i18n;
